import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, Redirect } from 'react-router-dom';
import Loadable from 'react-loadable';

import { IconRcMainLogo } from '@/assets/sidebar';
import { Banner, BannerDark } from '@/assets/welcome';
import { Button, SearchAddress, Loading } from '@/components';
import { Footer } from '@/components/DesktopFrame/components';
import { useTheme, useCurrentAddressInfo } from '@/hooks';
import { login } from '@/utils';

import style from './index.module.scss';

const Stream = Loadable({
  loader: () => import('../../Stream'),
  loading: () => <Loading />,
  delay: 500,
});

export const DesktopContainer = () => {
  const { isVerified } = useCurrentAddressInfo();
  const location = useLocation<{ freeze?: boolean; wantedLocation?: string }>();
  const { t } = useTranslation();
  const { isDark } = useTheme();

  // NeedLogin 带过来的，登陆之前点击的链接
  const wantedLocation = location.state?.wantedLocation;

  const handleLogin = useCallback(() => {
    login();
  }, []);

  // if (!isVerified && location.pathname !== '/') {
  //   history.replace('/');

  //   return null;
  // }

  if (!location.state?.freeze && isVerified) {
    // history.replace('/stream');
    // return null;

    return wantedLocation ? <Redirect to={wantedLocation} /> : <Stream />;
  }

  return (
    <div className={style.container}>
      <IconRcMainLogo className={style.mainLogo} />
      <div className={style.main}>
        <img src={isDark ? BannerDark : Banner} className={style.banner} alt="banner" />
        <div className={style.loginBlock}>
          <div className={style.title}>{t('DesktopContainer.1k04ozb')}</div>
          <Button className={style.loginBtn} type="primary" onClick={handleLogin}>
            {t('Welcome.oivb3w')}
          </Button>
          <div className={style.or}>
            <div className={style.orInner}>{t('DesktopContainer.2qr')}</div>
          </div>
          <SearchAddress
            className={style.searchInput}
            isShowRecent={false}
            includeOfficialAccount
            placeholder={t('DesktopContainer.1848161')}
            disableHi
            replaceAction
            iconAtEnd
          />
        </div>
      </div>
      <Footer className={style.footer} />
    </div>
  );
};
